/**
 * Ｐコード一発選定画面　出力VOクラス
 */
export class KYMW1304OutputModel {
  /** Ｐコード */
  public pcode: string = null;
}
